import { render, staticRenderFns } from "./apdMZonas.vue?vue&type=template&id=4d5f704c"
import script from "./apdMZonas.vue?vue&type=script&lang=js"
export * from "./apdMZonas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports